import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './component/app';
import configureStore from './configureStore';
import socket from './socket';
import { webPortalApi } from './config/web-portal-api';
import { whitelabel } from './config/whitelabel';

async function Init() {
  const { VITE_ROOT_URI, VITE_SOCKET_HOST } = import.meta.env;
  const rootUri = VITE_ROOT_URI || window.location.host;
  webPortalApi.init(rootUri);

  const i = document.createElement('link');
  i.rel = 'shortcut icon';
  i.href = whitelabel.buildAssetUrl('public/favicon.ico');
  document.head.appendChild(i);

  await whitelabel.initConfig();

  const store = configureStore(/* provide initial state if any */);

  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(
    <Provider store={store}>
      <App socket={socket(store, VITE_SOCKET_HOST)} />
    </Provider>
  );
}

Init();
